import { useControlledSliderWithOpenRange, useValueFilter } from '@/scopes/search/search/domain/hooks'
import { getFilterAISelection } from '@/scopes/search/search/infrastructure/store/selectors'
import { useSearchStoreSelector } from '@/scopes/search/search/infrastructure/store/useSearchStore'
import { Token } from '@sunwebgroup/ui-components/uds'
import { useCallback } from 'react'

export function PricePerPersonTokens() {
  const { isFetching, isLoading, resetFilterValues, selectedValue, setSelection } = useValueFilter('PricePerPerson')
  const { labelProps } = useControlledSliderWithOpenRange(selectedValue, setSelection)
  const aiSelectedValue = useSearchStoreSelector(getFilterAISelection, 'PricePerPerson') as [number, number | null] ?? []

  const handleRemoveClick = useCallback(() => {
    // This function is needed, as setting the value to undefined will throw an error from the mappper
    resetFilterValues('PricePerPerson')
  }, [resetFilterValues])

  if (isLoading)
    return null
  if (!selectedValue)
    return null

  return (
    <Token value={selectedValue.toString()} disabled={isFetching} dismissible onDismissClick={handleRemoveClick} icon={aiSelectedValue[0] === selectedValue[0] && aiSelectedValue[1] === selectedValue[1] ? 'Ai' : undefined}>
      {labelProps.formattedRange}
    </Token>
  )
}
